import { takeEvery, put, call } from "redux-saga/effects"

// Login Redux States
import { RESET_PASSWORD } from "./actionTypes"
import { userResetPasswordSuccess, apiError } from "./actions"

import { postJwtResetPwd } from "../../../helpers/backend_helper"

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* resetUser({ payload: { user, history } }) {
  try {
    const response = yield call(postJwtResetPwd, user)
    if (response) {
      yield put(userResetPasswordSuccess( "Password changed. Please login with a new password" ))
    }
  } catch (error) {
    const errorMessage = [error.response.data.error]
    yield put(apiError(errorMessage))
  }
}

function* resetPasswordSaga() {
  yield takeEvery(RESET_PASSWORD, resetUser)
}

export default resetPasswordSaga
